import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SequentalTokenDataOut } from '../../../../api/api-reference';

@Component({
  selector: 'app-token-retry-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './token-retry-dialog.component.html',
  styleUrl: './token-retry-dialog.component.scss',
})
export class TokenRetryDialogComponent {
  @Input() tokens: SequentalTokenDataOut[] = [];

  @Output() retry = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
